import * as THREE from 'three';
import type { SceneContext } from '../scene/setup';

export function createFloatingIndicator(
  ctx: SceneContext,
  text: string,
  x: number,
  z: number,
  isError = false,
): void {
  const { container, camera, renderer } = ctx;
  if (!renderer) return;

  const el = document.createElement('div');
  el.className = `absolute z-20 px-3 py-1.5 rounded-lg text-[11px] font-bold shadow-xl border transition-all duration-1000 pointer-events-none ${
    isError
      ? 'bg-red-950/95 text-red-400 border-red-500/50'
      : 'bg-slate-950/95 text-emerald-400 border-emerald-500/50'
  }`;
  el.textContent = text;
  container.appendChild(el);

  const pos = new THREE.Vector3(x, 2, z);

  const updatePos = (): void => {
    const tempV = pos.clone().project(camera);
    const rect = renderer.domElement.getBoundingClientRect();
    const x2d = (tempV.x * 0.5 + 0.5) * rect.width;
    const y2d = (tempV.y * -0.5 + 0.5) * rect.height;
    el.style.left = `${x2d - el.clientWidth / 2}px`;
    el.style.top = `${y2d - el.clientHeight / 2}px`;
  };

  updatePos();

  let currentY = 2;
  let opacity = 1;
  const animInterval = setInterval(() => {
    currentY += 0.05;
    pos.y = currentY;
    opacity -= 0.03;
    el.style.opacity = String(opacity);
    updatePos();

    if (opacity <= 0) {
      clearInterval(animInterval);
      el.remove();
    }
  }, 30);
}
